import { makeStyles } from '@material-ui/core/styles';

export const useIssueContainerStyles = makeStyles(() => ({
  rootDetailAccordion: {
    marginLeft: (props) => (props.mobile ? '' : 50),
    marginRight: (props) => (props.mobile ? '' : 50),
  },
  icon: {
    width: 40,
    height: 60,
    marginRight: 17,
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
  },
  subtitle: {
    fontSize: 14,
  },
  container: {
    border: (props) => (props.mobile ? '1px solid #BCBCBC' : ''),
    borderBottomStyle: 'none',
  },
  accordion: {
    '&.MuiAccordion-root.Mui-disabled': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
}));

export const modalConfirmationStyles = makeStyles((theme) => ({
  paper: {
    width: (props) => (props.mobile ? '' : 600),
    margin: 8,
    borderRadius: 4,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  buttonsContainer: {
    margin: 'auto !important',
    paddingBottom: 25,
  },
  normalText: {
    textAlign: 'center',
    color: '#464646',
  },
  title: {
    fontSize: 20,
    marginTop: 20,
    fontWeight: 600,
  },
  subtitle: {
    fontSize: 16,
    marginTop: 20,
  },
  purpleDetail: {
    color: '#6A148E',
    fontWeight: 500,
    fontSize: 22,
    marginTop: 12,
  },
  bodyText: {
    marginTop: (props) => (props.mobile ? 10 : 25),
    fontSize: 16,
  },
  image: {
    width: 100,
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}));

export const useEmptyStateTextStyles = makeStyles(() => ({
  typo1: {
    marginBottom: 20,
  },
  link: {
    textDecoration: 'none',
    color: 'black',
  },
}));

export const useIssuesListStyles = makeStyles(() => ({
  image: {
    margin: '20px auto',
    display: 'block',
  },
}));
